"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _dates = require("../../../utilities/dates");
var _Menu = require("../../Menu");
var _DatePicker = require("../DatePicker");
var _TimePicker = require("../TimePicker");
var _DateTimePickers = require("../DateTimePickers.labels");
var _DateTimePicker = _interopRequireDefault(require("./DateTimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getValidProps = props => {
  const {
    dateTime: dateTimeProp,
    minDateTime: minDateTimeProp,
    maxDateTime: maxDateTimeProp,
    minutesStep
  } = props;
  let minDateTime = minDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(minDateTimeProp), minutesStep, true) : undefined;
  let maxDateTime = maxDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(maxDateTimeProp), minutesStep, false) : undefined;
  if (minDateTime && maxDateTime && minDateTime > maxDateTime) {
    minDateTime = maxDateTime;
  }

  // TODO: Temporary removed because test automation failure. should fix automation and back to this version in the future!
  //const dateTime = restrictToMinDate(restrictToMinuteStep(dateTimeProp, minutesStep), minDateTimeProp);
  const dateTime = (0, _dates.restrictToMinDate)(dateTimeProp, minDateTimeProp);
  return {
    ...props,
    dateTime,
    minDateTime,
    maxDateTime
  };
};
const DateTimePicker = props => {
  const styles = (0, _DateTimePicker.default)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    dateTime,
    minDateTime,
    maxDateTime,
    anchorSubTextDate,
    anchorSubTextTime,
    datePickerTitle,
    timePickerTitle,
    minutesStep,
    isDisabled,
    btnProps: defaultBtnProps,
    onChange
  } = getValidProps(props);
  const [selectedDateTime, setSelectedDateTime] = (0, _react.useState)((0, _dates.restrictToMinuteStep)(dateTime, minutesStep));
  const [minHour, setMinHour] = (0, _react.useState)();
  const [maxHour, setMaxHour] = (0, _react.useState)();
  const [minMinute, setMinMinute] = (0, _react.useState)();
  const [maxMinute, setMaxMinute] = (0, _react.useState)();
  const btnProps = {
    color: 'basic',
    view: 'outlined',
    shape: isMobileView ? 'roundedRectangle' : 'ellipse',
    customStyle: {
      width: isMobileView ? '100%' : 'auto'
    },
    isDisabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-DateTimePicker__anchor-btn'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(dateTime, '{hour}:{minute}')
          }), anchorSubTextTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextTime
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(dateTime, '{day}.{month}.{year}')
          }), anchorSubTextDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextDate
          })]
        })]
      })
    }),
    ...defaultBtnProps
  };
  const updateMinMaxTimeValues = dateTime => {
    // In case when user select min/max date in range:
    // Set max/min available time (hour + minute) values

    const isMinDateSelected = minDateTime && dateTime.toDateString() === minDateTime.toDateString();
    setMinHour(isMinDateSelected ? minDateTime.getHours() : undefined);
    setMinMinute(isMinDateSelected && dateTime.getHours() <= minDateTime.getHours() ? minDateTime.getMinutes() : undefined);
    const isMaxDateSelected = maxDateTime && dateTime.toDateString() === maxDateTime.toDateString();
    setMaxHour(isMaxDateSelected ? maxDateTime.getHours() : undefined);
    setMaxMinute(isMaxDateSelected && dateTime.getHours() >= maxDateTime.getHours() ? maxDateTime.getMinutes() : undefined);
  };
  const handleDateChange = date => {
    const newSelectedDate = new Date(selectedDateTime);
    newSelectedDate.setDate(date.getDate());
    newSelectedDate.setMonth(date.getMonth());
    newSelectedDate.setFullYear(date.getFullYear());
    if (minDateTime && newSelectedDate < minDateTime) {
      newSelectedDate.setHours(minDateTime.getHours(), minDateTime.getMinutes(), 0, 0);
    } else if (maxDateTime && newSelectedDate > maxDateTime) {
      newSelectedDate.setHours(maxDateTime.getHours(), maxDateTime.getMinutes(), 0, 0);
    }
    updateMinMaxTimeValues(newSelectedDate);
    setSelectedDateTime(newSelectedDate);
  };
  const handleTimeChange = (hour, minute) => {
    const newSelectedTime = new Date(selectedDateTime);
    newSelectedTime.setHours(hour, minute, 0, 0);
    updateMinMaxTimeValues(newSelectedTime);
    setSelectedDateTime(newSelectedTime);
  };
  const handleConfirm = () => {
    if (onChange) {
      onChange(selectedDateTime);
    }
  };
  const handleCancel = () => {
    setSelectedDateTime(dateTime);
    updateMinMaxTimeValues(dateTime);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-DateTimePicker'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.Menu, {
      defaultTitle: getLabel('choose_date_time'),
      isBoxCenteredToAnchor: true,
      anchorWidth: isMobileView ? 'auto' : 'fit-content',
      btnProps: btnProps,
      isWithActionButtons: true,
      isFullScreen: isMobileView,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      children: [datePickerTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-DateTimePicker__date-title'],
        children: datePickerTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.DatePicker, {
        minDate: minDateTime,
        maxDate: maxDateTime,
        selectedDate: selectedDateTime,
        onChange: handleDateChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-DateTimePicker__time'],
        children: [timePickerTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-DateTimePicker__time-title'],
          children: timePickerTitle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePicker.TimePicker, {
          defaultTime: selectedDateTime,
          minHour: minHour,
          minMinute: minMinute,
          maxHour: maxHour,
          maxMinute: maxMinute,
          minutesStep: minutesStep,
          onChange: handleTimeChange
        })]
      })]
    })
  });
};
exports.DateTimePicker = DateTimePicker;